<template>
	
	<view style="width: 100%;height: 100%;background-color: #fff;" >

		<view class="mk-center nav" style="position: relative;">
			<!-- #ifndef MP-WEIXIN -->
			<view style="position: absolute;left: 20rpx;top: 0;" @tap="back">
				<uni-icons type="back" size="50r" color="#252525"></uni-icons>
			</view>
			<!-- #endif -->
			<block v-for="(it,ind) in navs" :key="ind">
			<text :class="{nav_this: pageSign == ind}" @tap="setPage(ind)">{{ it }}</text>
			</block>
			<view style="position: absolute;right: 20rpx;top: 0;" @tap="toHome">
				<uni-icons type="home" size="40r"></uni-icons>
			</view>
		</view>
		<view v-if="pageSign == 0">
			<swiper :duration="1000" :current="current" style="height: 440rpx;width: 100%;margin-top: 10rpx;">
				<swiper-item v-for="(url, index) in baseInfo.pic" :key="index">
					<image :src="url" mode="aspectFit" style="width: 100%;"></image>
				</swiper-item>
			</swiper>
			<view class="pic-dot"><text>{{current+1}} / {{picNum}}</text></view>
			<view style="width: 100%;height: 70rpx;border-bottom: 1rpx solid #c8c7cc;margin-top: 40rpx;">
				<text style="float: left;font-size: 32rpx;line-height: 70rpx;margin-left: 30rpx;">{{ baseInfo.part_name }}</text>
				<view style="float: right;line-height: 70rpx;font-size: 28rpx;margin-right: 30rpx;color: #138c81;" @click="productCorrecting">
					<uni-icons type="compose" size="30r" color="#138c81"></uni-icons>
					<text>产品纠错</text>
				</view>
			</view>
			<view class="desc">
				<text>{{ baseInfo.prb_name }}: {{ baseInfo.pri_code }}</text>
			</view>
			<view class="desc" v-if="baseInfo.para.length > 0">
				<text v-for="(item,index) in baseInfo.para" class="desc">
					{{ item.name }}: {{ item.val }}{{ item.unit }}
				</text>
			</view>
		</view>
		<view v-if="pageSign == 1" style="background-color: #fff;">
			<view v-for="(item,index) in carInfo" :key="index" style="margin-left: 20rpx;">
				<uni-icons v-if="item.opSign == 0" type="plus-filled" size="30r" @click="op(item)"></uni-icons>
				<uni-icons v-if="item.opSign == 1" type="minus-filled" size="30r" @click="op(item)"></uni-icons>
				<text @click="op(item)">{{item.brand_name}}</text>
				<block v-if="item.opSign == 1">
					<view v-for="(item2,index2) in item.sun" :key="index2" style="margin-left: 40rpx;">
						<uni-icons v-if="item2.opSign == 0" type="plus-filled" size="30r" @click="op(item2)"></uni-icons>
						<uni-icons v-if="item2.opSign == 1" type="minus-filled" size="30r" @click="op(item2)"></uni-icons>
						<view class="tree-item" @click="op(item2)">
							{{item2.mod2_name}}
							<text class="tree-year">{{item2.mod2_start_year}}-{{item2.mod2_end_year}}</text>
						</view>
						<block v-if="item2.opSign == 1">							
							<view v-for="(item3,index3) in item2.sun" :key="index3" style="margin-left: 60rpx;">
								<text class="tree-tx1">{{item3.mod3_name}} {{item3.mod3_start_year}}-{{item3.mod3_end_year}}</text>
								<text class="tree-tx2">{{item3.mod3_engine}} {{item3.mod3_kw}}kw {{item3.mod3_cc}}cc {{item3.mod3_transmission}} {{item3.mod3_drive}} {{item3.mod3_fuel}}</text>
							</view>
						</block>
					</view>
				</block>
			</view>
		</view>
		<view v-if="pageSign == 2"  style="background-color: #fff;">
			<view v-for="(ite,ind) in engineInfo" style="padding: 20rpx 30rpx;border-bottom: 1rpx solid #c8c7cc;">
				<text>{{ite.brand_name}} {{ite.engine}} {{ite.kw}}kw {{ite.cc}}cc {{ite.fuel}}</text>
			</view>
		</view>
		<view v-if="pageSign == 3 || pageSign == 4"  style="background-color: #fff;">
			<view class="table-tab">
				<text :class="{table_tab_this:pageSign == 3}" @tap="setPage(3)">OE</text>
				<text :class="{table_tab_this:pageSign == 4}" @tap="setPage(4)">参考号</text>
			</view>
			<view v-if="pageSign == 3" style="margin-top: 20rpx;">
				<view class="table-head">
					<text class="tab-left">品牌</text>
					<text class="tab-right">号码</text>
				</view>
				<view class="table-body">
					<view v-for="(ite,ind) in numberInfo.oe">
						<text class="tab-left">{{ite.factory}}</text>
						<text class="tab-right">{{ite.display}}</text>
					</view>
				</view>
			</view>
			<view v-if="pageSign == 4" style="margin-top: 20rpx;">
				<view class="table-head">
					<text class="tab-left">品牌</text>
					<text class="tab-right">号码</text>
				</view>
				<view class="table-body">
					<view v-for="(ite,ind) in numberInfo.refer">
						<text class="tab-left">{{ite.factory}}</text>
						<text class="tab-right">{{ite.display}}</text>
					</view>
				</view>
			</view>
		</view>
		<uni-popup ref="popup">
			<view class="jiucuo-box" style="width: 600rpx;">
				<view class="close-btn" @click="closePop">
					<uni-icons type="close" size="50r" color="#cecece;"></uni-icons>
				</view>
				<view style="background-color: #FFFFFF;padding: 70rpx 30rpx;border-radius: 6rpx;">
					
					<view class="jc-title">
						<text>{{ baseInfo.part_name }}产品纠错</text>
					</view>
					<view class="textarea">
						<textarea class="textarea-style" style="padding: 10rpx;" v-model="jc_txt" value="" placeholder="请输入纠错信息（至少5个字符）" />
					</view>
					<view class="input-row">
						<text class="text-label">图片</text>
						<view v-if="imgUrl == ''" >
							<view class="uploadimg" @click="chooseImg">
								<image style="position: relative; left: 40rpx;top: 40rpx; height: 60rpx;width: 60rpx;" src="/static/active/icon-camera.png" mode=""></image>
							</view>
						</view>
						<view v-if="imgUrl" class="delimgCont">
							<view class="uploadimg" >
								<image :src="imgUrl" style="height: 100%;width: 100%;" mode=""></image>
							</view>
							<uni-icons @click="delImg" class="delImgClass" type="close" size="40r"  color="#3d3d3d;"></uni-icons>
						</view>
					</view>
					<view class="input-row" style="margin-top: 20rpx;" @click="addJiuCuo">
						<button class="btn">提交纠错</button>	
					</view>
				</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	const app = getApp();
	export default {
		onLoad(option) {
			console.log(option)
			this.proId = option.proId
			this.fetchData()
		},
		data() {
			return {
				navs: ['基本信息','车型','发动机','互换号'],
				proId: 0,
				current: 0,
				picNum: 0,
				pageSign: 0,
				baseInfo: {},
				carInfo: {},
				engineInfo: [],
				numberInfo: {oe: [], refer: []},
				jc_txt:'', //纠错内容
				imgUrl:'' ,//纠错图片
				sfileList:[]
			}
		},
		methods: {
			back() {
				uni.navigateBack()
			},
			toHome() {
				uni.switchTab({url:'/pages/index/index'})
			},
			setPage(page) {
				this.pageSign = page
				console.log()
				this.fetchData()
			},
			op(item) {
				if (item.opSign == 0) {
					item.opSign = 1
					if (item.lv == 0) {
						this.fetchCarLv1(item.brand_id,item.make_id)
					} else {
						this.fetchCarLv2(item.brand_id,item.make_id,item.mod2_id)
					}
				} else {
					item.opSign = 0
				}
			},
			fetchData() {
				let fetchMap = ['fetchBase','fetchCar','fetchEngine','fetchOe','fetchRefer']
				let fnName = fetchMap[this.pageSign]
				this[fnName]()
			},
			fetchBase() {
				let that =this
				if (Object.keys(this.baseInfo).length == 0) {
					app.getApi('GET','data/itemDes?isAjax=1&type=super&proId='+this.proId, {}, 1, function(res){
						that.baseInfo = res
						that.picNum = that.baseInfo.pic.length
					})
				}
			},
			fetchCar(lv = 0) {
				let fnName = 'fetchCarLv' + lv
				this[fnName]()
			},
			fetchCarLv0() {
				let that =this
				app.getApi('GET','data/itemModelTree?isAjax=1&type=super&mod_type=ypc&mod_level=0&proId='+this.proId, {}, 1, function(res){
					for(let i in res) {
						res[i].opSign = 0
						res[i].lv = 0
						that.carInfo[res[i].brand_id+'-'+res[i].make_id] = res[i]
					}
					that.carInfo = JSON.parse(JSON.stringify(that.carInfo))
				})
			},
			fetchCarLv1(brandId,makeId) {
				let that =this
				if (!('sun' in that.carInfo[brandId+'-'+makeId])) {
					that.carInfo[brandId+'-'+makeId].sun = {}
					let param = 'isAjax=1&type=super&mod_type=ypc&mod_level=1&proId='+this.proId+'&brand_id='+brandId+'&make_id='+makeId
					app.getApi('GET','data/itemModelTree?'+param, {}, 1, function(res){
						for(let i in res) {
							res[i].opSign = 0
							res[i].lv = 1
							res[i].brand_id = brandId
							res[i].make_id = makeId
							that.carInfo[brandId+'-'+makeId].sun[res[i].mod2_id] = res[i]
						}
						that.carInfo = JSON.parse(JSON.stringify(that.carInfo))
					})
				}
			},
			fetchCarLv2(brandId,makeId,mod2Id) {
				let that =this
				if (!('sun' in that.carInfo[brandId+'-'+makeId].sun[mod2Id])) {
					that.carInfo[brandId+'-'+makeId].sun[mod2Id].sun = {}
					let param = 'isAjax=1&type=super&mod_type=ypc&mod_level=2&proId='+this.proId+'&mod2_id='+mod2Id
					app.getApi('GET','data/itemModelTree?'+param, {}, 1, function(res){
						that.carInfo[brandId+'-'+makeId].sun[mod2Id].sun = res
					})
					that.carInfo = JSON.parse(JSON.stringify(that.carInfo))
				}
			},
			fetchEngine() {
				let that =this
				if (this.engineInfo.length == 0) {
					let data = {isAjax: 1,type: 'super', proId: this.proId}
					app.getApi('GET','data/itemEngine?isAjax=1&type=super&proId='+this.proId, {}, 1, function(res){
						that.engineInfo = res
					})
				}
			},
			fetchOe() {
				let that =this
				if (this.numberInfo.oe.length == 0) {
					let data = {isAjax: 1,type: 'super', proId: this.proId, numtype: 'oe'}
					app.getApi('GET','data/itemNumber?isAjax=1&type=super&numtype=oe&proId='+this.proId, data, 1, function(res){
						that.numberInfo.oe = res
					})
				}
			},
			fetchRefer() {
				let that =this
				if (this.numberInfo.refer.length == 0) {
					let data = {isAjax: 1,type: 'super', proId: this.proId, numtype: 'ref'}
					app.getApi('GET','data/itemNumber?isAjax=1&type=super&numtype=ref&proId='+this.proId, data, 1, function(res){
						that.numberInfo.refer = res
					})
				}
			},
			// 产品纠错
			productCorrecting(){
				this.$refs.popup.open()
			},
			//关闭
			closePop(){
				this.$refs.popup.close()
			},
			img2base64(url)
			{
				// #ifdef MP-WEIXIN
				return new Promise((reslove,reject) => {
					reslove('data:image/jpeg;base64,'+uni.getFileSystemManager().readFileSync(url,'base64'));
				})
				// #endif
				
				// #ifdef H5
				return new Promise((reslove,reject) => {
					uni.request({
						url: url,
						method: 'GET',
						responseType: 'arraybuffer',
						success(res) {
							let base64 = 'data:image/jpeg;base64,' + uni.arrayBufferToBase64(res.data)
							reslove(base64);
						},
						fail(err) {
							// return '图片转换失败'
							reject('图片转换失败');
						}
					})
				})
				// #endif
				
				
			},
			uploadImg(img){
				let that = this;
				that.img2base64(img).then(res=>{
					let base64 = res;
					let data = {
						site:'b2c',
						cate:'advise',
						imgurl:base64,
					}
					app.getApi('POST','data/uploadImg', data, 1, function(res){
						that.imgUrl = res.url;
						that.sfileList.push(res.sfile); 
					})
				})
			},
			
			// 上传纠错图片	
			chooseImg(){
				let that = this
				uni.chooseImage({
					count: 1,
					success: function (res) {
						that.uploadImg(res.tempFilePaths[0]);
			
					}
				});
			},
			//删除纠错图片
			delImg(){
				this.imgUrl = '';
			},
			// 提交纠错
			addJiuCuo(){
				let params = {
					jc_type:'item',
					jc_txt:this.jc_txt,
					jc_pro_id:this.baseInfo.pro_id,
					jc_imgs:this.sfileList.join(',')
				};
				
				app.getApi('POST','super/addSuperJiuCuo',params,1,function(result){
					
					uni.showToast({
						title: '提交成功', icon: 'none' 
					})
					that.closePop();
					
				})
			}
		}
	}
</script>

<style>
	.mk-center {display: flex;align-items: center;justify-content: center;}
	.nav {height: 70rpx;width: 100%;background-color: #f7f7f7;box-shadow: 0 1px 6px #ccc;}
	.nav text{line-height: 70rpx;margin: 0 10rpx;padding: 0 14rpx;}
	.nav .nav_this {color: #e7181e;border-bottom: 2px solid #e7181e;}
	.desc {padding: 0 30rpx;font-size: 30rpx;border-bottom: 1rpx solid #c8c7cc;}
	.pic-dot {text-align: center;margin-top: 10rpx;}
	.pic-dot text {border-radius: 20px;padding: 4px 10px;color: #fff;background: rgba(0,0,0,0.5);}
	.tree-item{display: inline;}
	.tree-year {color: gray;margin-left: 10rpx;}
	.tree-tx1 {display: block;font-size: 30rpx;}
	.tree-tx2 {font-size: 26rpx;direction: rtl;color: gray;}
	.table-tab{display: flex;align-items: center;justify-content: center;background-color: #efeff4;}
	.table-tab text{display: block;width: 48%;text-align: center;height: 60rpx;line-height: 60rpx;}
	.table_tab_this{background-color: #fff;color: #e7181e;}
	.table-head,.table-body{display: flex;align-items: center;justify-content: center;}
	.table-head text{border: 1px solid #e6e6e6;background-color: #f2f2f2;display: inline-block;padding-left: 20rpx;}
	.table-body text{border: 1px solid #e6e6e6;display: inline-block;padding-left: 20rpx;}
	.tab-left{width: 250rpx;}
	.tab-right{width: 420rpx;}
	.jc-title{text-align: left;}
	.uploadimg{
		width: 160rpx;
		height: 160rpx;
		background-color: #e5e5e5;
	}
	.textarea-style{
		width: 95%;
		border-radius:6rpx;
		border: 1rpx solid rgba(0,0,0,.2);
	}
	.input-row{display: flex;margin-top: 10rpx;}
	.text-label{width: 25%;}
	.imgcode{display: flex;}
	.jc_imgcode{height: 60rpx;}
		
	.btn{
		font-size: 28rpx;
		width: 200rpx;
		font-weight: 400;
		line-height: 2;
		color: #fff;
		border: 1px solid #007aff;
		background-color: #007aff;
	}
	.close-btn{
		position: absolute;
		width: 60rpx;
		height: 60rpx;
		right: 0;
		/* font-size: 30px; */
		top: 0;
		color: #333;
	}
	.delimgCont{
		position: relative;
	}
	.delImgClass{
		height: 40rpx;
		position: absolute;
		right: 0rpx; 
		top: -10rpx;
	}
</style>
